<template>
  <v-dialog v-model="dialog" persistent width="1300">
    <v-card>
      <!-- Cabecera del formulario -->
      <v-card-title class="headline">
        <v-flex xs9> <v-icon>picture_as_pdf</v-icon> REPORTE </v-flex>
        <v-spacer></v-spacer>
        <v-btn flat icon title="Ver en otra ventana" @click="openNewWindow()">
          <v-icon>fullscreen</v-icon>
        </v-btn>
        <v-btn icon @click.native="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-layout>
          <v-flex>
            <embed
              :src="obtenerUrl()"
              type="application/pdf"
              width="100%"
              height="700px"
            />
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  // Variables iniciales
  data() {
    return {
      form: {},
      dialog: false,
      loading: false,
      url: "",
      api_backend: "",
      user: this.$storage.get("user"),
      id_persona: -1
    };
  },
  mounted() {
    this.$bus.$on("openDialogVerReportePermiso", item => {
      console.log()
      //this.tipo_documento = this.obtenerTipo(item)
      this.form = item;
      this.url = "";
      this.url = this.obtenerUrl();
      this.api_backend = process.env.API_URL.split("api/");
      this.dialog = true;
      this.id_persona = this.$route.params.id
        ? this.$route.params.id
        : this.$route.params.id_persona
        ? this.$route.params.id_persona
        : this.user.id_persona;
    });
  },
  methods: {
    obtenerUrl() {
      try {
        let url;
        let nombre_reporte = "";
        let formato_doc = "output=pdf";
        let nombre_carpeta = "permisos";
        let url_carpeta = process.env.REPORTE_URL_OFICIAL.replace(
          /{carpeta}/g,
          nombre_carpeta
        );
        if (this.form.id_tipo_permiso == 14) {
          //LICENCIA PERSONAL DS 25749   14
          nombre_reporte = "rpt_ds_25749";
        }

        if (this.form.id_tipo_permiso == 105) {
              //LICENCIA QUE LA ENTIDAD OTORGUE 105
          nombre_reporte = "rpt_entidad_otorgue";
        }

        if (this.form.id_tipo_permiso == 89) {
          //ASUETO POR CUMPLEAÑOS   89
          nombre_reporte = "rpt_por_cumpleanios";
        }
        //FORMULARIO DE REGISTRO DE ASISTENCIAS
        if (this.form.id_tipo_permiso == 94) {
          if (
            this.form.id_permiso_omision ||
            this.form.id_permiso_omision != null
          ) {
            //reporte de permisos
            nombre_reporte = "rpt_registro_asistencia_permisos";
          } else {
            //reporte de horarios regulares
            nombre_reporte = "rpt_registro_asistencia";
          }
        }
        if (this.form.id_tipo_permiso == 24) {
          // PAPELETA DE SOLICITUD CON CARGO A VACACION   24
          nombre_reporte = "rpt_cargo_vacacion";
        }
        if (this.form.id_tipo_permiso == 97) {
          //  CONTROL DE ASISTENCIA
          nombre_reporte = "rpt_permiso_oficial_horas";
        }
        if (this.form.id_tipo_permiso == 8) {
          //  JUSTIFICATIVO CAJA
          nombre_reporte = "rpt_justificativo_caja";
        }
        if (this.form.id_tipo_permiso == 96) {
          // TOLERANCIA
          nombre_reporte = "rpt_tolerancia";
        }
        if (this.form.id_tipo_permiso == 6) {
          //LICENCIA POR DUELO (D.S. 25749)
          nombre_reporte = "rpt_por_duelo";
        }
        if (this.form.id_tipo_permiso == 61) {
          //  LICENCIA POR PATERNIDAD
          nombre_reporte = "rpt_por_paternidad";
        }
        if (this.form.id_tipo_permiso == 98) {
          //  LICENCIA POR DIA DEL PADRE
          nombre_reporte = "rpt_por_dia_padre";
        }
        if (this.form.id_tipo_permiso == 99) {
          //  LICENCIA POR DIA DE LA MADRE
          nombre_reporte = "rpt_por_maternidad";
        }
        if (this.form.id_tipo_permiso == 12) {
          //  LICENCIA POR MATRIMONIO    12
          nombre_reporte = "rpt_por_matrimonio";
        }
        if (this.form.id_tipo_permiso == 88) {
          //  PERMISO PARTICULAR CON GOCE DE HABER      88
          nombre_reporte = "rpt_con_goce_haber";
        }
        if (
          this.form.id_tipo_permiso >= 37 &&
          this.form.id_tipo_permiso <= 43
        ) {
          // TOLERANCIA PAPANICOLAOU, MAMOGRAFIAS O PROSTATA LEY 252 – 798   -37 al 43   24
          nombre_reporte = "rpt_ley_252_798";
        }
/*
        if (this.form.id_tipo_permiso == 37) {
          //TOLERANCIA MAMA Y PAPANICOLAOU (LEY N° 798-252)      37
          nombre_reporte = "rpt_r_961";
        }
        if (this.form.id_tipo_permiso == 40) {
          //TOLERANCIA COLON (ANAMNESIS Y EXÁMEN FÍSICO LEY N° 798-252)      40
          nombre_reporte = "rpt_r_991";
        }
        if (this.form.id_tipo_permiso == 41) {
          //TOLERANCIA EXÁMEN FÍSICO DE PRÓSTATA (LEY N° 798-252)      41
          nombre_reporte = "rpt_r_994";
        }
        if (this.form.id_tipo_permiso == 42) {
          //TOLERANCIA EXÁMENES COMPLEMENTARIOS (LEY N° 798-252) (D.S. 3164)      42
          nombre_reporte = "rpt_r_916";
        }
        if (this.form.id_tipo_permiso == 43) {
          //TOLERANCIA EXÁMEN DE LABORATORIO (PSA)(LEY N° 798-252)     43
          nombre_reporte = "rpt_r_960";
        }
*/
        if (this.form.id_tipo_permiso == 44) {
          //LICENCIA ESPECIAL D.S.Nº 3462  R-0923    44
          //nombre_reporte = "rpt_ds_padres_3462";
          nombre_reporte = "rpt_r_0923";
        }
        if (this.form.id_tipo_permiso == 87) {
          //permiso oficial por hrs     87
          nombre_reporte = "rpt_permiso_oficial_horas";
        }

        if (this.form.id_tipo_permiso == 104) {
          //permiso cursos     104
          nombre_reporte = "rpt_cursos_becas_seminarios";
        }
        

        if (this.form.id_tipo_permiso == 102) {
          //trabajo continuo     102
          nombre_reporte = "rpt_trabajo_continuo";
        }
        if (this.form.id_tipo_permiso == 5) {
          //CENSO 2024          5
          nombre_reporte = "rpt_censo_2024";
        }

        ////////////// WC
        if (this.form.id_tipo_permiso == 103) {
          ///////R-0947 COMISIÓN DE TRABAJO 103
          nombre_reporte = "rpt_r_0947";
          console.log('redireccionar reporte 103...', nombre_reporte);
        }

        if (this.form.id_tipo_permiso == 18) {
          //// 18 R-0995 PERMISO PERSONAL SIN GOCE DE HABERES
          nombre_reporte = "rpt_r_0995";
          console.log('redireccionar reporte 18...', nombre_reporte);
        }

        if (this.form.id_tipo_permiso == 90) {
          //// 90 R-0921 BAJA MEDICA
          nombre_reporte = "rpt_r_0921";
          console.log('redireccionar reporte 90...', nombre_reporte);
        }




        url = `${url_carpeta}${nombre_reporte}&${formato_doc}`;
        //Parametros
        let id_permiso = this.form.id_permiso;
        let url_parametros;
        // URL con parametros
        if (
          this.form.id_tipo_permiso != 89 &&
          this.form.id_tipo_permiso != 102
        ) {
          url_parametros = `${url}&p_id_permiso=${id_permiso}&p_id_persona=${this.id_persona}`;
        }
        // if (this.form.id_tipo_permiso==24) {
        //   url_parametros = `${url}&p_id_permiso=${id_permiso}&p_id_persona=${this.id_persona}`;
        // }
        if (this.form.id_tipo_permiso == 89) {
          let user = this.$storage.get("user");
          url_parametros = `${url}&p_id_permiso=${id_permiso}&p_nombre_usuario=${user.usuario}`;
        }
        if (this.form.id_tipo_permiso == 102) {
          let user = this.$storage.get("user");
          url_parametros = `${url}&p_id_permiso=${id_permiso}`;
        }
        // REPORTE CENSO
        if (this.form.id_tipo_permiso == 5) {
          let user = this.$storage.get("user");
          url_parametros = `${url}&P_ID_PERMISO=${id_permiso}&P_ID_USUARIO=${user.id}`;
        }






//// 



        console.log(url_parametros);
        return url_parametros;
      } catch (error) {
        console.log(error);
      }
    },
    close() {
      this.loading = false;
      this.dialog = false;
      this.url = "";
      this.$bus.$emit("closeDialogVerReportePermiso");
    },
    openNewWindow() {
      window.open(this.url);
    }
  }
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/admin/permiso/dialogs/VerReporte.vue